import { CreateAppointmentInput, PartnerOrganization } from './API';

export default function isDirectToConsumer(
  appointment: Pick<CreateAppointmentInput, 'partnerOrganization'> | null | undefined,
): boolean {
  return (
    appointment?.partnerOrganization == null ||
    appointment?.partnerOrganization === PartnerOrganization.DRVILLIVALAM
  );
}
